/**
 * Crazy Egg — OneTrust Consent Gate
 *
 * OneTrust auto-blocking is not enabled on this site, so the Crazy Egg
 * tag can't rely on the type="text/plain" + optanon-category-* pattern.
 * This loads the script manually once OneTrust reports the client's
 * "Performance and Functionality" category (C0007) as active, via the 
 * OptanonWrapper callback OneTrust invokes on initial consent and on 
 * every preference change.
 *
 * Setup:
 *   Remove the existing Crazy Egg <script> tag from layout/theme.liquid
 *   and replace it with:
 *     <script src="{{ 'crazyegg-consent.js' | asset_url }}" defer></script>
 *   Place it after the OneTrust script tag, before </head>.
 */

const CONSENT_CATEGORY = "C0007";
const CRAZY_EGG_SRC = "//script.crazyegg.com/pages/scripts/0037/5640.js";

(function (w, d) {
  let loaded = false;

  function hasConsent() {
  return ("," + (w.OnetrustActiveGroups || "") + ",").indexOf("," + CONSENT_CATEGORY + ",") > -1;
  }

  function loadCrazyEgg() {
    if (loaded) return;
    loaded = true;

    const s = d.createElement("script");
    s.src = CRAZY_EGG_SRC;
    s.async = true;
    d.head.appendChild(s);
  }

  function checkConsent() {
    if (hasConsent()) loadCrazyEgg();
  }

  const existingOptanonWrapper = w.OptanonWrapper;
  w.OptanonWrapper = function () {
    if (typeof existingOptanonWrapper === "function") existingOptanonWrapper();
    checkConsent();
  };

  // Covers the case where consent was already granted in an earlier
  // session and OptanonWrapper fires before this script runs.
  checkConsent();
})(window, document);
